import { Typography } from 'lighthouse';

import { QuickKeywordsProps } from './models';

export function QuickKeywords({ keywords, onSelect, hint, title = 'پرتکرار:' }: QuickKeywordsProps) {
    if (!keywords.length) return null;

    return (
        <div className='mt-3 flex flex-col gap-2'>
            <div role='group' aria-label={title} className='flex flex-wrap items-center gap-2'>
                <Typography variant='caption' component='span' color='blackMediumEmphasis' className='shrink-0 font-bold'>
                    {title}
                </Typography>
                {keywords.map((keyword) => (
                    <button
                        key={keyword}
                        type='button'
                        onClick={() => onSelect(keyword)}
                        className='cursor-pointer whitespace-nowrap rounded-full border border-solid border-N200 bg-white px-3.5 py-2 text-sm
                            text-blackHighEmphasis [font-family:inherit] active:scale-[0.97] active:bg-primary/5'>
                        {keyword}
                    </button>
                ))}
            </div>
            {!!hint && (
                <Typography variant='caption' component='p' color='blackMediumEmphasis' className='leading-6'>
                    {hint}
                </Typography>
            )}
        </div>
    );
}
